/** A column header of the bulk-upload example table, with a red asterisk on a required field. */
import { Flex, FlexItem } from "@ryerson/frontend.layout";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import React from "react";

interface ExampleFileStructureTableHeaderProps {
	headerTitle: string;
	isFieldMandatory?: boolean;
}

/** Renders `headerTitle`, starred when `isFieldMandatory`. */
const ExampleFileStructureTableHeader: React.FC<ExampleFileStructureTableHeaderProps> = ({
	headerTitle,
	isFieldMandatory = false,
}) => {
	const { theme } = useTheme();
	const { error, header } = theme.colors.primary;

	return (
		<Flex
			css={{
				maxWidth: 111.5,
				height: "100%",
			}}
			alignContent="center"
			alignItems="center"
			justifyContent="flex-start"
		>
			<FlexItem>
				<Typography size="sm" color={header}>
					{headerTitle}
					{isFieldMandatory && <Typography color={error}>&nbsp;*</Typography>}
				</Typography>
			</FlexItem>
		</Flex>
	);
};

export default ExampleFileStructureTableHeader;
